var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 3",
    d: "M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 7ZM23.7071 8.7071C24.0976 8.31658 24.0976 7.68342 23.7071 7.29289L17.3431 0.928931C16.9526 0.538406 16.3195 0.538406 15.9289 0.928931C15.5384 1.31946 15.5384 1.95262 15.9289 2.34314L21.5858 8L15.9289 13.6569C15.5384 14.0474 15.5384 14.6805 15.9289 15.0711C16.3195 15.4616 16.9526 15.4616 17.3431 15.0711L23.7071 8.7071ZM1 9L23 9L23 7L1 7L1 9Z",
    fill: "#D2042D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/Arrow 3.94e9cf289077a8adbd674b9a84a73a38.svg";
export { ForwardRef as ReactComponent };